import { useTranslation } from "react-i18next";

import { PFA_STATUS } from "~/api/physicalFitnessAssessments";
import type { PFAStatus } from "~/api/physicalFitnessAssessments";
import { Badge } from "~/ui";

interface PFAStatusBadgeProps {
  status: PFAStatus;
}

export const PFAStatusBadge = ({ status }: PFAStatusBadgeProps) => {
  const { t } = useTranslation();

  const badgeMapping = {
    [PFA_STATUS.EXCELLENT]: (
      <Badge text={t("pfas.excellent")} type="solid" color="success" />
    ),
    [PFA_STATUS.SATISFACTORY]: (
      <Badge text={t("pfas.satisfactory")} type="solid" color="warning" />
    ),
    [PFA_STATUS.UNSATISFACTORY]: (
      <Badge text={t("pfas.unsatisfactory")} type="solid" color="error" />
    ),
  };

  return badgeMapping[status];
};
